import { create, doMocked, isMocked, read } from "../api";
import { key } from "./action";
export const SERVICE_ENDPOINT = "services";
export const SERVICE_ENDPOINT_READ_SERVICES = `${SERVICE_ENDPOINT}/read`;
export const SERVICE_ENDPOINT_CREATE_MODEL = `${SERVICE_ENDPOINT}/create`;

export const readServices = () => {
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_READ_SERVICES);
  return read(`${SERVICE_ENDPOINT}`, null, true);
};

export const createModel = (body) => {
  const { modelType } = body;
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_CREATE_MODEL);
  return create(`${SERVICE_ENDPOINT}/${modelType}`, body, true, false);
};
